import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a wall-mounted bathroom mirror authored at its true
// mounting height: a glass-tone panel 0.6 x 0.8 m centred around y = 1.5 in a
// thin matte-black frame, flat against the wall at z = 0, facing +Z.
const GLASS = "#9fc4d4";
const FRAME = "#2e2e30";

export const wallMirror = defineModel({
  id: "wall-mirror",
  batchId: "modern",
  name: "Wall mirror",
  tags: ["modern", "interior", "fixture", "bathroom", "mirror", "wall-mounted"],
  summary: "A wall-mounted mirror in a thin matte-black frame.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // thin frame backing against the wall
      { geometry: new THREE.BoxGeometry(0.66, 0.86, 0.03), color: FRAME, position: [0, 1.5, 0.015] },
      // mirror glass, slightly proud of the frame
      { geometry: new THREE.BoxGeometry(0.6, 0.8, 0.015), color: GLASS, position: [0, 1.5, 0.035] },
    ];
  },
  animations: [],
});
